/**
 * @module Menu Helpers
 * @description
 */
import { MouseEvent } from 'react';
import { trackEvent } from 'ui/js/helpers/tracking';
import { addPageAction } from 'ui/js/utils/new-relic';

/**
 * @function setA11y
 * @description
 */
export const setA11y = ( element: HTMLElement, index: number, prefix: string ) => {
   const { parentNode } = element;

   if( ! parentNode ) return;

   element.setAttribute( 'id', `${ prefix }-menu-item-${ index }` );
   element.setAttribute( 'aria-haspopup', 'true' );
   element.setAttribute( 'aria-controls', `${ prefix }-menu-submenu-${ index }` );
   element.setAttribute( 'aria-expanded', 'false' );

   const submenu = parentNode.querySelector( '.submenu-wrap' );

   if ( ! submenu ) return;

   submenu.setAttribute( 'role', 'menu' );
   submenu.setAttribute( 'id', `${ prefix }-menu-submenu-${ index }` );
   submenu.setAttribute( 'aria-labelledby', `${ prefix }-menu-item-${ index }` );
};

/**
 * @function handleClick
 * @description
 */
export const handleClick = ( event: MouseEvent ) => {
  const { target } = event;

  // @ts-ignore:next-line
  const payload = JSON.parse( target.getAttribute( 'data-payload' ) );
  const { text, actionOutcome, position } = payload;

  const data = {
    elementType: 'BUTTON',
    location: 'GLOBAL',
    position,
    text,
    actionOutcome
  };

  trackEvent( { action: 'elementClicked', data, event } );
};

/**
 * @function handleBuyClick
 * @description
 */
export const handleBuyClick = ( event: MouseEvent ) => {
  addPageAction( 'cartEntrance', { method: 'MASTHEAD' } );
  handleClick( event );
};
